import EntidadeCompraCamposPersonalizados from './entidade-compra-campos-personalizados';
import EntidadeRequisicaoCamposPersonalizados from './entidade-requisicao-campos-personalizados';

const getCamposPersonalizadosCompraById = async id => new Promise((resolve) => {
  resolve(EntidadeCompraCamposPersonalizados.keys[id]);
});

const getCamposPersonalizadosRequisicaoById = async id => new Promise((resolve) => {
  resolve(EntidadeRequisicaoCamposPersonalizados.keys[id]);
});

export default {
  getCamposPersonalizadosCompraById,
  getCamposPersonalizadosRequisicaoById,
};
